// wrapper for AveoNetworkTools plugin
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
export const NetworkTools = {
    cancelPortScan: () => __awaiter(void 0, void 0, void 0, function* () {
        return new Promise((resolve, reject) => {
            AveoNetworkTools.cancelPortScan(resolve, (message) => __awaiter(void 0, void 0, void 0, function* () { return reject(new Error(message)); }));
        });
    }),
    ping: (ipAddress, options) => __awaiter(void 0, void 0, void 0, function* () {
        return new Promise((resolve, reject) => {
            AveoNetworkTools.ping(ipAddress, options !== null && options !== void 0 ? options : {}, resolve, (message) => __awaiter(void 0, void 0, void 0, function* () { return reject(new Error(message)); }));
        });
    }),
    portScan: (ipAddress, options) => __awaiter(void 0, void 0, void 0, function* () {
        return new Promise((resolve, reject) => {
            AveoNetworkTools.portScan(ipAddress, options !== null && options !== void 0 ? options : {}, resolve, (message) => __awaiter(void 0, void 0, void 0, function* () { return reject(new Error(message)); }));
        });
    }),
    queryArpCache: (ipAddress) => __awaiter(void 0, void 0, void 0, function* () {
        return new Promise((resolve, reject) => {
            AveoNetworkTools.queryArpCache(ipAddress, resolve, (message) => __awaiter(void 0, void 0, void 0, function* () { return reject(new Error(message)); }));
        });
    }),
    wakeOnLan: (ipAddress, macAddress, options) => __awaiter(void 0, void 0, void 0, function* () {
        return new Promise((resolve, reject) => {
            AveoNetworkTools.wakeOnLan(ipAddress, macAddress, options !== null && options !== void 0 ? options : {}, resolve, (message) => __awaiter(void 0, void 0, void 0, function* () { return reject(new Error(message)); }));
        });
    }),
};
